<div class="app-layout">
    <ukata-loading></ukata-loading>
    <aside
      [class.collapsed]="isCollapsed"
      class="menu-sidebar"
      id="app-sidebar"
      >
      <div class="sidebar-logo">
        <img alt="Ukata icon" src="assets/icons/icon-72x72.png"/>
      </div>
      <mat-nav-list class="sidebar-nav">
        <h3 matSubheader>Dashboard</h3>
        <a
          (click)="hideMenu()"
          mat-list-item
          routerLink="user/dashboard"
          routerLinkActive="active-link"
          >Dashboard</a
          >
          @if (isMaker) {
            <h3 matSubheader>Maker</h3>
            <a
              (click)="hideMenu()"
              mat-list-item
              routerLink="/maker/quizzes"
              routerLinkActive="active-link"
              >Create quizzes</a
              >
              <a
                (click)="hideMenu()"
                mat-list-item
                routerLink="/maker/courses"
                routerLinkActive="active-link"
                >{{ "maker.courses.create-course" | translate }}</a
                >
              }
              @if (isAdmin) {
                <h3 matSubheader>Admin</h3>
                <a
                  (click)="hideMenu()"
                  mat-list-item
                  routerLink="/admin/dashboard"
                  routerLinkActive="active-link"
                  >Admin dashboard</a
                  >
                  <a
                    (click)="hideMenu()"
                    mat-list-item
                    routerLink="/admin/tools"
                    routerLinkActive="active-link"
                    >Admin tools</a
                    >
                    <a
                      (click)="hideMenu()"
                      mat-list-item
                      routerLink="/admin/user-attempts"
                      routerLinkActive="active-link"
                      >User attempts</a
                      >
                      <a
                        (click)="hideMenu()"
                        mat-list-item
                        routerLink="/admin/create-toeic-tests"
                        routerLinkActive="active-link"
                        >Create TOEIC Tests</a
                        >
                        <a
                          (click)="hideMenu()"
                          mat-list-item
                          routerLink="/admin/speaking-scenarios"
                          routerLinkActive="active-link"
                          >Speaking Scenarios</a
                          >
                        }
                      </mat-nav-list>
                    </aside>
                    <div class="app-main" [style.margin-left.px]="isCollapsed ? 0 : 256" id="main-app">
                      <header class="app-header-bar">
                        <div class="app-header">
                          <span (click)="isCollapsed = !isCollapsed" class="header-trigger">
                            <span class="material-symbols-outlined">
                              @if (!isCollapsed) {
                                <span>close</span>
                              }
                              @if (isCollapsed) {
                                <span>menu</span>
                              }
                            </span>
                          </span>
                          <div class="right-menu">
                            <mat-icon
                              [matMenuTriggerFor]="profileMenu"
                              color="primary"
                              fontSet="material-symbols-outlined"
                              style="cursor: pointer;"
                              >account_circle
                            </mat-icon>
                            <mat-menu #profileMenu="matMenu">
                              <button mat-menu-item routerLink="/user/profile">
                                <mat-icon fontSet="material-symbols-outlined">person</mat-icon>
                                <span>Profile</span>
                              </button>
                              <button mat-menu-item (click)="logout()">
                                <mat-icon fontSet="material-symbols-outlined">logout</mat-icon>
                                <span>Logout</span>
                              </button>
                            </mat-menu>
                          </div>
                        </div>
                      </header>
                      <div class="app-content">
                        <div class="inner-content">
                          <router-outlet></router-outlet>
                        </div>
                      </div>
                    </div>
                </div>
